exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".brand__bg{\n    width: 100%;\n    height: 244px;\n    position: relative;\n}\n\n.brand__bg--img{\n    position: absolute;\n    top: 0;\n    left: 0;\n    width: 100%;\n    height: 100%;\n    object-fit: cover;\n}\n\n@media(max-width: 768px){\n    .brand__bg {\n        height: unset;\n        padding-top: 25%;\n    }\n}\n@media(max-width: 480px){\n    .brand__bg{\n        height: 100px;\n    }\n}", ""]);

// exports
